/**
* This file was automatically generated by quicktype.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run command(npm run schemabuild) to regenerate this file.
*/
/**
 * 分享内容类型
 */
export var SinaWeiboContentType;
(function (SinaWeiboContentType) {
    SinaWeiboContentType["Image"] = "image";
    SinaWeiboContentType["Link"] = "link";
    SinaWeiboContentType["Text"] = "text";
})(SinaWeiboContentType || (SinaWeiboContentType = {}));
